// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as SlabsTable from "../SlabsTable.bs.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Date$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CorePricingStatusVm from "../../../vm-mapper/CorePricingStatusVm.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as CorePricingActionManager from "../../../library/CorePricingActionManager.bs.js";
import * as CorePricingDetailsFooter from "./CorePricingDetailsFooter.bs.js";
import * as VehicleGeoRegionTitleBar from "./VehicleGeoRegionTitleBar.bs.js";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";

var info_icon = PricingDashboardAssetsManager.getImage("info-icon.svg");

function CorePricingDetails$PendingCampaignWarning(Props) {
  var start_date = Props.start_date;
  var status = Props.status;
  var match = Timestamp$Catalyst.isBefore(start_date, Timestamp$Catalyst.now(undefined));
  if (status !== 1 || !match) {
    return null;
  } else {
    return React.createElement("div", {
                className: "c-warning-banner"
              }, React.createElement("img", {
                    src: info_icon
                  }), React.createElement("p", undefined, "This campaign was scheduled to go live on " + (Timestamp$Catalyst.toString(start_date, "DD/MM/yyyy") + ". If Approved this will now be "), React.createElement("b", undefined, " effective from " + Date$Catalyst.toString("DD/MM/yyyy", Date$Catalyst.tomorrow(undefined)))));
  }
}

var PendingCampaignWarning = {
  info_icon: info_icon,
  make: CorePricingDetails$PendingCampaignWarning
};

function CorePricingDetails$LineItem(Props) {
  var label = Props.label;
  var unit = Props.unit;
  var value = Props.value;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: ""
            }, unit !== undefined ? React.createElement(LabelUnit$Catalyst.make, {
                    label: label,
                    unit: unit
                  }) : React.createElement("div", undefined, label), React.createElement("div", undefined, value));
}

var LineItem = {
  make: CorePricingDetails$LineItem
};

function CorePricingDetails(Props) {
  var campaign = Props.campaign;
  var role = Props.role;
  var closeSidebar = Props.closeSidebar;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var actions = CorePricingActionManager.getActionsByRoleAndStatus(role, campaign.status);
  var match$1 = campaign.status;
  var end_date = campaign.end_date;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "campaign-details-section"
                }, React.createElement(CorePricingDetails$PendingCampaignWarning, {
                      start_date: campaign.start_date,
                      status: campaign.status
                    }), React.createElement(VehicleGeoRegionTitleBar.make, {
                      vehicle_name: campaign.vehicle_name,
                      geo_region: campaign.region_name
                    }), React.createElement(CardComponent$Catalyst.make, {
                      className: "campaign-primary-info-card",
                      children: null
                    }, React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, "Status"), React.createElement("div", {
                              className: CorePricingStatusVm.toString(campaign.status)
                            }, CorePricingStatusVm.toString(campaign.status))), React.createElement(CorePricingDetails$LineItem, {
                          label: "Created By",
                          value: campaign.created_by
                        }), React.createElement(CorePricingDetails$LineItem, {
                          label: "Created On",
                          value: Timestamp$Catalyst.toString(campaign.created_on, "DD/MM/YYYY")
                        }), match$1 !== 1 ? React.createElement(React.Fragment, undefined, React.createElement("hr", {
                                className: "separator"
                              }), React.createElement(CorePricingDetails$LineItem, {
                                label: "Approved By",
                                value: campaign.approved_by
                              }), React.createElement(CorePricingDetails$LineItem, {
                                label: "Approved On",
                                value: campaign.approved_on
                              })) : null), React.createElement(CardComponent$Catalyst.make, {
                      className: "campaign-primary-info-card",
                      children: null
                    }, React.createElement(CorePricingDetails$LineItem, {
                          label: "Start Date",
                          unit: "dd/mm/yyyy",
                          value: Timestamp$Catalyst.toString(campaign.start_date, "DD/MM/yyyy")
                        }), end_date !== undefined ? React.createElement(CorePricingDetails$LineItem, {
                            label: "End Date",
                            unit: "dd/mm/yyyy",
                            value: Timestamp$Catalyst.toString(Caml_option.valFromOption(end_date), "DD/MM/yyyy")
                          }) : null, React.createElement("hr", {
                          className: "separator"
                        }), React.createElement(CorePricingDetails$LineItem, {
                          label: "Base Fare",
                          unit: currency,
                          value: Currency.toCurrencyString(campaign.base_fare, currency)
                        }), React.createElement("hr", {
                          className: "separator"
                        }), React.createElement(CorePricingDetails$LineItem, {
                          label: "Free Duration",
                          unit: "min",
                          value: String(campaign.free_duration) + " mins"
                        }), React.createElement(CorePricingDetails$LineItem, {
                          label: "Waiting Rate per min",
                          unit: currency + "/min",
                          value: Currency.toCurrencyString(campaign.waiting_rate, currency)
                        }), React.createElement("hr", {
                          className: "separator"
                        }), React.createElement(CorePricingDetails$LineItem, {
                          label: "Free KMs",
                          unit: "kms",
                          value: String(campaign.free_kms) + " KMs"
                        }), React.createElement(CorePricingDetails$LineItem, {
                          label: "Price per min for free KMs",
                          unit: currency + "/min",
                          value: Currency.toCurrencyString(campaign.free_km_price_per_min, currency)
                        })), React.createElement(SlabsTable.make, {
                      slabs: campaign.slabs
                    })), React.createElement(CorePricingDetailsFooter.make, {
                  actions: actions,
                  campaign_id: campaign.campaign_id,
                  campaign_name: campaign.campaign_name,
                  closeSidebar: closeSidebar
                }));
}

var make = CorePricingDetails;

export {
  PendingCampaignWarning ,
  LineItem ,
  make ,
  
}
/* info_icon Not a pure module */
